import { render, staticRenderFns } from "./AcoesCancelarDeclaracaoVencedor.vue?vue&type=template&id=75e6d6e3&scoped=true"
import script from "./AcoesCancelarDeclaracaoVencedor.vue?vue&type=script&lang=js"
export * from "./AcoesCancelarDeclaracaoVencedor.vue?vue&type=script&lang=js"
import style0 from "./AcoesCancelarDeclaracaoVencedor.vue?vue&type=style&index=0&id=75e6d6e3&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e6d6e3",
  null
  
)

export default component.exports